
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"x":".25","y":".25","width":"15.5","height":"15.5","rx":"1.75","stroke":"currentColor","stroke-width":".5"}}),_c('path',{attrs:{"d":"M12.842 9.172c-.222-.267-.677-.396-1.392-.396-.415 0-.917.044-1.492.132-1.57-1.16-2.008-2.44-2.008-2.44s.268-.69.285-1.817c.01-.713-.099-1.193-.38-1.472A.695.695 0 007.384 3a.616.616 0 00-.368.118c-.817.604.074 3.45.098 3.525-.385.958-.87 1.973-1.37 2.865-.162.29-.146.267-.283.503 0 0-1.382.655-2.052 1.46-.378.456-.426.763-.406.997v.005c.032.276.382.527.733.527l.044-.001c.357-.023.749-.28 1.197-.785.296-.334.68-.92 1.143-1.745 1.328-.382 2.497-.654 3.477-.81.718.391 1.787.834 2.515.834.244 0 .44-.05.583-.15.171-.118.244-.266.29-.54.045-.273-.018-.48-.144-.631zm-1.551.333c.638 0 .984.094 1.162.172a.753.753 0 01.122.068c-.05.032-.148.073-.326.073-.295 0-.682-.104-1.155-.31l.197-.003zM7.506 3.57l.002-.003c.137.073.2.585.188.882-.018.398-.022.552-.09.797-.188-.51-.202-1.427-.1-1.676zm.05 4.038c.322.528.8 1.1 1.26 1.51-.898.191-1.76.432-2.297.619.575-.993 1-2.031 1.037-2.13zM3.86 12.166c.078-.13.29-.385.83-.876-.37.562-.641.869-.917 1.06a1.18 1.18 0 01.087-.184z","fill":"currentColor"}})])
          )
        }
      }
    